<template>
  <div>
    <el-dialog
      title="Select Resume"
      :visible.sync="this.ShowControl"
      :show-close="false"
      :append-to-body="true"
      width="700px"
      class="ts-modal"
    >
      <button
        type="button"
        aria-label="Close"
        class="el-dialog__headerbtn"
        @click="closeControl(null)"
      >
        <i class="el-dialog__close el-icon el-icon-close"></i>
      </button>
      <p>Select from the list of resume to export your data</p>
      <el-row>
        <div v-for="(item, index) in ProfileSettings" :key="index">
          <el-col
            :xl="12"
            :lg="12"
            :md="12"
            :sm="12"
            :xs="24"
            style="padding: 20px;"
          >
            <el-row :gutter="40">
              <el-col :xl="8" :lg="10" :md="10" :sm="10" :xs="24">
                <!-- <router-link :to="'/profile/' + item.UserId + '/' + item.Id" target="_blank">
                            <qrcode-vue :value="rURL + '/profile/' + item.UserId + '/'  + item.Id" :size="size" level="H" style="text-align:center"></qrcode-vue>
                            </router-link> -->
                <label @click="selectResume(item)">
                  <qrcode-vue
                    :value="rURL + '/profile/' + item.userId + '/' + item.id"
                    level="H"
                    style="text-align:center"
                  ></qrcode-vue>
                </label>
              </el-col>
              <el-col :xl="16" :lg="14" :md="14" :sm="14" :xs="24">
                <label
                  v-if="item.profileName == 'Default'"
                  style="font-weight: bold;font-size: 16px;"
                  @click="selectResume(item)"
                  >Default Resume</label
                >
                <label
                  v-else
                  style="font-weight: bold;font-size: 16px;"
                  @click="selectResume(item)"
                  >{{ item.profileName }}</label
                >
                <br />
                <label style="font-size: 14px;">{{
                  item.profileConfiguration.personalStatement
                }}</label
                ><br />
              </el-col>
            </el-row>
          </el-col>
        </div>
      </el-row>
    </el-dialog>
  </div>
</template>

<script>
import QrcodeVue from "qrcode.vue";
export default {
  components: {
    QrcodeVue
  },
  name: "ResumeListSection",
  props: {
    ShowControl: {
      type: Boolean,
      default: false
    },
    ProfileSettings: {
      type: Array,
      default: []
    }
  },
  data() {
    return {};
  },
  computed: {
    rURL() {
      return window.location.host;
    }
  },
  methods: {
    closeControl() {
      this.$emit("close-control");
    },
    selectResume(setting) {
      this.$emit("show-resume", setting);
    }
  }
};
</script>

<style scoped>
#task_id_Others {
  display: none;
}
</style>
